import { BrowserRouter, Routes, Router,  Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider, useAuth } from './contexts/AuthContext'

// Pages
import LandingPage from './pages/LandingPage'
import ScanPage from './pages/ScanPage'
import AssignPage from './pages/AssignPage'
import AssignSuccessPage from './pages/AssignSuccessPage'
import CinetPayPage from './pages/CinetPayPage' // Nouvelle page de paiement
import PaymentSuccessPage from './pages/PaymentSuccessPage' // Nouvelle page succès paiement
import AdminLogin from './pages/admin/AdminLogin'
import AdminDashboard from './pages/admin/AdminDashboard'
import CustomerDashboard from './pages/customer/CustomerDashboard'
import NotFound from './pages/NotFound'
import ContactPage from './pages/ContactPage'
import AboutPage from './pages/AboutPage'
import SupportPage from './pages/SupportPage'
import FAQPage from './pages/FAQPage'
import LegalPage from './pages/LegalPage'
import PrivacyPage from './pages/PrivacyPage'
import ScrollToTop from './components/ScrollToTop'

import PaymentStatus from './pages/PaymentStatus'

// Composant de protection de route
function ProtectedRoute({ children, role = 'user' }) {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="spinner"></div>
          <p className="mt-md" style={{ color: 'var(--color-text-secondary)' }}>
            Chargement...
          </p>
        </div>
      </div>
    )
  }
  
  if (!user) {
    return <Navigate to={role === 'admin' ? '/admin/login' : '/'} replace />
  }
  
  if (role === 'admin' && user.role !== 'admin') {
    return <Navigate to="/" replace />
  }
  
  return children
}

// Composant de route publique seulement si non connecté
function PublicOnlyRoute({ children, redirectTo = '/dashboard' }) {
  const { user, loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="spinner"></div>
          <p className="mt-md" style={{ color: 'var(--color-text-secondary)' }}>
            Chargement...
          </p>
        </div>
      </div>
    )
  }
  
  if (user) {
    return <Navigate to={redirectTo} replace />
  }
  
  return children
}

function AppContent() {
  return (
    
    <Routes>
     
      {/* Routes publiques */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/scan/:qrId" element={<ScanPage />} />
      
      {/* Routes d'assignation */}
      <Route path="/assign/:qrId" element={<AssignPage />} />
      <Route path="/assign/success/:qrId" element={<AssignSuccessPage />} />
      
      {/* Routes de paiement */}
      <Route path="/payment" element={<CinetPayPage />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />



  
<Route path="/payment/status" element={<PaymentStatus />} />




      
      {/* Route admin login - accessible seulement si non connecté */}
      <Route path="/admin/login" element={
        <PublicOnlyRoute redirectTo="/admin/dashboard">
          <AdminLogin />
        </PublicOnlyRoute>
      } />
      
      {/* Routes protégées admin */}
      <Route path="/admin/dashboard" element={
        <ProtectedRoute role="admin">
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/dashboard/:tab" element={
        <ProtectedRoute role="admin">
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/qr/:qrId" element={
        <ProtectedRoute role="admin">
          <AdminDashboard />
        </ProtectedRoute>
      } />
      
      {/* Routes protégées utilisateur */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <CustomerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/:tab" element={
        <ProtectedRoute>
          <CustomerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/objects/:objectId" element={
        <ProtectedRoute>
          <CustomerDashboard />
        </ProtectedRoute>
      } />
      
      {/* Routes de support */}
      <Route path="/privacy" element={
        <div className="min-h-screen flex items-center justify-center">
          <div className="card max-w-2xl">
            <h2 className="mb-md">Politique de confidentialité</h2>
            <p className="text-muted mb-md">
              Cette page est en construction. Le contenu sera bientôt disponible.
            </p>
            <a href="/" className="btn btn-primary">
              Retour à l'accueil
            </a>
          </div>
        </div>
      } />
      
      <Route path="/terms" element={
        <div className="min-h-screen flex items-center justify-center">
          <div className="card max-w-2xl">
            <h2 className="mb-md">Conditions d'utilisation</h2>
            <p className="text-muted mb-md">
              Cette page est en construction. Le contenu sera bientôt disponible.
            </p>
            <a href="/" className="btn btn-primary">
              Retour à l'accueil
            </a>
          </div>
        </div>
      } />
      
      <Route path="/contact" element={
        <div className="min-h-screen flex items-center justify-center">
          <div className="card max-w-2xl">
            <h2 className="mb-md">Contact</h2>
            <p className="text-muted mb-md">
              Cette page est en construction. Le contenu sera bientôt disponible.
            </p>
            <a href="/" className="btn btn-primary">
              Retour à l'accueil
            </a>
          </div>
        </div>
      } />
      
      {/* Route de test QR (pour développement) */}
      <Route path="/test-qr/:id" element={
        <div className="min-h-screen flex items-center justify-center">
          <div className="card text-center">
            <h2 className="mb-md">QR Code Test: {window.location.pathname.split('/').pop()}</h2>
            <p className="text-muted mb-md">
              Ceci est une page de test pour vérifier les QR codes
            </p>
            <div className="flex gap-md justify-center">
              <a href="/" className="btn btn-primary">
                Retour à l'accueil
              </a>
              <a href={`/assign/${window.location.pathname.split('/').pop()}`} className="btn btn-outline">
                Tester l'assignation
              </a>
              <a href={`/payment?plan=5-stickers`} className="btn btn-accent">
                Tester paiement
              </a>
            </div>
          </div>
        </div>
      } />
      
      {/* 404 - Doit être la dernière route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

function App() {
  return (
    <BrowserRouter>
          <ScrollToTop />

      <AuthProvider>
        <AppContent />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'var(--color-background)',
              color: 'var(--color-text-primary)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--border-radius-md)',
              fontFamily: 'var(--font-family)',
            },
            success: {
              style: {
                borderLeft: '4px solid var(--color-success)',
              },
            },
            error: {
              style: {
                borderLeft: '4px solid var(--color-error)',
              },
            },
            loading: {
              style: {
                borderLeft: '4px solid var(--color-primary)',
              },
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App